import { render } from "./SiteMarquee.vue?vue&type=template&id=1bbd4b90&scoped=true"
import script from "./SiteMarquee.vue?vue&type=script&lang=js"
export * from "./SiteMarquee.vue?vue&type=script&lang=js"

import "./SiteMarquee.vue?vue&type=style&index=0&id=1bbd4b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbd4b90"]])

export default __exports__